export default __webpack_public_path__ + "static/media/avatar2.78371cb8.png";